import {
  Text,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  // TableContainer,
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Tfoot,
  // useDisclosure,
  Checkbox,
  HStack,
  // Stack,
  VStack,
  Box,
  Spinner,
  IconButton,
  FormLabel,
  FormControl,
  FormHelperText,
  InputGroup,
  Input,
  InputRightElement,
  Center,
  Link,
  useDisclosure,
  Heading,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { PhoneNumberUtil } from "google-libphonenumber";
// import { ethers } from 'ethers';
import { showError } from "../../common/errors";
import Strings from "../../config/Strings";
import { /*FiDelete, FiTrash,*/ FiCheck, FiTrash2 } from "react-icons/fi";
import { PhoneInput } from "react-international-phone";

import "react-international-phone/style.css";
import PaymentStrings from "./PaymentStrings";
import { FaBullseye } from "react-icons/fa";
import CancelAlert from './CancelAlert';
import {getRegionName, getCountryName} from './RegionMap';
import { WarningTwoIcon } from "@chakra-ui/icons";
import { NEED_SUBSCRIPTION_MSG } from "../../common/constants";
const UIStatus = {
  Check: 0,
  AddPayment: 1,
  TrailUser: 2,
  Subscribe: 3,
  ManageSubscription: 4,
};

const ACCOUNT_INITIAL_BALANCE = 500;
const phoneUtil = PhoneNumberUtil.getInstance();
const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};

const translateProductName = (name) => {
  name = name.toLowerCase();
  if (name === 'sms') {
    return PaymentStrings.sms;
  } else if (name === 'email') {
    return PaymentStrings.email;
  } else if (name === 'contract') {
    return PaymentStrings.contract;
  } else if (name === 'bridge') {
    return PaymentStrings.bridge;
  }
  return name;
};

function calculateTotalAmountV1(product, start, usage) {
  // let productName = product.name;
  
  if (usage === 0) {
    const price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
    return {
      total: 0,
      lines: [
        {
          description: `0 × ${translateProductName(product.name)} (${PaymentStrings.tier} 1 ${PaymentStrings.at} $${price} / ${PaymentStrings.unit})`,
          pricing: {
            unit_amount_decimal: product.tiers[0].unit_amount,
          },
          quantity: 0,
          amount: 0,
        }
      ]
    };
  }

  let total = start + usage;
  if (total < 50) {
    const price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
    const total_amount = usage * product.tiers[0].unit_amount
    return {
      total: total_amount,
      lines: [
        {
          description: `${usage} × ${product.name} (${PaymentStrings.tier} 1 ${PaymentStrings.at} $${price} / ${PaymentStrings.unit})`,
          pricing: {
              unit_amount_decimal: product.tiers[0].unit_amount,
          },
          quantity: usage,
          amount: total_amount,
        }
      ]
    };
  };

  let t1 = start < 50 ? 50 - start : 0;
  let t2 = usage - t1;

  let tire1 = t1 * product.tiers[0].unit_amount;
  let tire2 = t2 * product.tiers[1].unit_amount;
  
  const tire1Price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
  const tire2Price = (product.tiers[1].unit_amount * 0.01).toFixed(2);
  if (t1 === 0) {
    return {
      total: tire1 + tire2,
      lines: [{
        description: `${t2} × ${product.name} (${PaymentStrings.tier} 2 ${PaymentStrings.at} $${tire2Price} / ${PaymentStrings.unit})`,
        pricing: {
            unit_amount_decimal: product.tiers[1].unit_amount,
        },
        quantity: t2,
        amount: tire2,
      }]
    };
  }

  return {
      total: tire1 + tire2,
      lines: [
      {
          description: `${t1} × ${product.name} (${PaymentStrings.tier} 1 ${PaymentStrings.at} $${tire1Price} / ${PaymentStrings.unit})`,
          pricing: {
              unit_amount_decimal: product.tiers[0].unit_amount,
          },
          quantity: t1,
          amount: tire1,
      },
      {
          description: `${t2} × ${product.name} (${PaymentStrings.tier} 2 ${PaymentStrings.at} $${tire2Price} / ${PaymentStrings.unit})`,
          pricing: {
              unit_amount_decimal: product.tiers[1].unit_amount,
          },
          quantity: t2,
          amount: tire2,
      }
  ]};
};


function calculateTotalAmount(product, start, usage, isTrailUser=false) {
  
  const paymentEnv = localStorage.getItem('app.payment-env');
  if (paymentEnv === 'test') {
    return calculateTotalAmountV1(product, start, usage);
  }

  const tiersInfo = [];
  if (product.pid === 'contract') {
    if (isTrailUser) {
      tiersInfo.push({
        no: 1,
        start: 1,
        end: Number.MAX_SAFE_INTEGER,
        price: 42
      });
    } else {
      if (start < 20) {
        tiersInfo.push({
          no: 1,
          start: 1,
          end: 20,
          price: 42
        });
      }
      if (start < 40) {
        tiersInfo.push({
          no: 2,
          start: 21,
          end: 40,
          price: 32
        })
      }
      if (start < 60) {
        tiersInfo.push({
          no: 3,
          start: 41,
          end: 60,
          price: 22
        })
      }
      tiersInfo.push({
        no: 4,
        start: 61,
        end: Number.MAX_SAFE_INTEGER,
        price: 15
      })
    }
  } else if (product.pid === 'sms') {

    tiersInfo.push({
      no: 1,
      start: 1,
      end: Number.MAX_SAFE_INTEGER,
      price: 5
    })
  } else if (product.pid === 'email') {
    
    tiersInfo.push({
      no: 1,
      start: 1,
      end: Number.MAX_SAFE_INTEGER,
      price: 5
    })
  } else if (product.pid === 'bridge') {
    tiersInfo.push({
      no: 1,
      start: 1,
      end: Number.MAX_SAFE_INTEGER,
      price: 5
    })
  }


  if (usage === 0) {
    
    const price = (tiersInfo[0].price * 0.01).toFixed(2);
    return {
      total: 0,
      lines: [
        {
          description: `0 × ${translateProductName(product.name)} (${PaymentStrings.tier} 1 ${PaymentStrings.at} $${price} / ${PaymentStrings.unit})`,
          pricing: {
            unit_amount_decimal: tiersInfo[0].price,
          },
          quantity: 0,
          amount: 0,
        }
      ]
    };
  }

  if (tiersInfo.length === 0) {

    const price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
    const total_amount = usage * product.tiers[0].unit_amount
    return {
      total: total_amount,
      lines: [
        {
          description: `${usage} × ${product.name} (${PaymentStrings.tier} 1 ${PaymentStrings.at} $${price} / ${PaymentStrings.unit})`,
          pricing: {
              unit_amount_decimal: product.tiers[0].unit_amount,
          },
          quantity: usage,
          amount: total_amount,
        }
      ]
    };
  }
  
  let total = start + usage;
  let offset = 0;
  const lines = [];
  let total_amount = 0;
  for(let tierInfo of tiersInfo) {
    if (start + offset >= total) {
      break;
    }

    let cap = tierInfo.end - (start + offset);
    const usageInTier = Math.min(usage - offset, cap);
    offset += usageInTier;

    const price = (tierInfo.price * 0.01).toFixed(2);
    const line_amount = (usageInTier * tierInfo.price);
    total_amount += line_amount;
      
    lines.push({
      description: `${usageInTier} × ${product.name} (${PaymentStrings.tier} ${tierInfo.no} ${PaymentStrings.at} $${price} / ${PaymentStrings.unit})`,
      pricing: {
          unit_amount_decimal: tierInfo.price,
      },
      quantity: usageInTier,
      amount: line_amount
    });

  }
  return {
    total: total_amount,
    lines: lines
  };
}

function CheckPanel({ message }) {
  return (
    <Center minHeight={"400px"}>
      <HStack justifyContent={"center"}>
        <Spinner size={"sm"} color={"orange"} />
        <Text color={"orange"}>{message}</Text>
      </HStack>
    </Center>
  );
}

function AddPaymentPanel({profile, setProfile, isPaying, setPaying, updateBalance, subscriptionContext, setSubscriptionContext}) {
  const [isLoading, setLoading] = useState(false);
  var [timeoutId, setTimeoutId] = useState(-1);

  const doCheckPayment = async() => {
    let checkoutSessionId = subscriptionContext && subscriptionContext.checkoutSessionId;
    if (!checkoutSessionId) {
      if (profile && profile.data) {
        checkoutSessionId = profile.data;
      }
    }
    if (!checkoutSessionId) {
      return -1;
    }
    console.log('doCheckPayment - checkoutSessionId: ', checkoutSessionId);
    let result = await window.plexiMailService.checkSubscriptionCheckoutStatusDirectly(checkoutSessionId);
    if (result.code !== 0) {
      return -1;
    }
    if (result.data.paymentStatus !== 'paid' || result.data.subscriptionStatus !== 'active') {
      return -2;
    }
    result = await window.plexiMailService.checkSubscriptionCheckoutStatus();
    if (result.code !== 0) {
      return -1;
    }
    setSubscriptionContext({...subscriptionContext, paymentStatus: result.data.paymentStatus})
    if (result.data.paymentStatus !== 'paid' || result.data.subscriptionStatus !== 'active') {
      return -2;
    }
    const p = await window.plexiMailService.getUserProfile();
    if (p) {
      setProfile(p);
    }
    if (updateBalance) {
      updateBalance();
    }
    return 0;
  };
  
  const checkPayment = async() => {
    try {
      const res = await doCheckPayment();
      if (res === 0) {
        return;
      } else {
        const promise = new Promise((resolve, reject) => {
          const id = setTimeout(resolve, 5000);
          timeoutId = id;
          setTimeoutId(id);
        }) 
        await promise;
        await checkPayment();
      }
    } catch (e) {
      console.error(e);
      showError(e);
      await checkPayment();
    }
  };

  const saveUserProfileIfNeeded = async () => {

    const p = await window.plexiMailService.getUserProfile(false);
    if (p) {
      setProfile(p);
      return p;
    } else {
      const p1 = { country: "US", subscriptionId: "", customerId: "", subscriptionStatus: "", data: "", isTrail: false };
      await window.plexiMailService.saveUserProfile("x", "y", p1);
      setProfile(1);
      return p1;
    }
  }
  const getCheckoutSession = async(checkoutSessionId) => {
    let result = await window.plexiMailService.checkSubscriptionCheckoutStatusDirectly(checkoutSessionId);
    if (result.code !== 0) {
      // return await window.plexiMailService.createSubscriptionCheckoutSession();;
      throw new Error('Failed to retrieve checkout session')
    }
    if (result.data.status === 'expired' || !result.data.url || result.data.url === '') {
      return await window.plexiMailService.createSubscriptionCheckoutSession();
    }
    
    // checkPayment().then(e => {

    // }).catch(e => {
    //   console.error(e);
    //   showError(e);
    // });
    return {code: 0, msg: 'success', data: {
      sessionId: result.data.id,
      url: result.data.url,
      isPaying: result.data.status === 'complete'
    }};
  };

  const createCheckoutSessionIfNeeded = async(profile) => {

    if (profile.data && profile.data.length > 0) {
      return getCheckoutSession(profile.data);
    } else {
      return window.plexiMailService.createSubscriptionCheckoutSession();
    }
  };

  useEffect(() => {

    setLoading(true);
    saveUserProfileIfNeeded().then(profile => {
      return createCheckoutSessionIfNeeded(profile).then( result => {
        return {result, profile};
      })
    }).then(object => {
      const {result, profile} = object;
        setLoading(false);
        if (!result || result.code !== 0) {
          throw new Error(PaymentStrings.failed_to_create_checkout_session);
        }
        setSubscriptionContext({ ...subscriptionContext, checkoutSessionId: result.data.sessionId, checkoutSessionUrl: result.data.url});
        
        if (!result.data.isPaying) {
          console.log('fetchAllProductsAndCreateCheckout - checkoutSessionId: ', result.data.sessionId);
          setProfile({...profile, data: result.data.sessionId});
        }
        if (result.data.isPaying) {
          setPaying(true);
        }
    }).catch(e => {
      setLoading(false);
      console.error(e);
      showError(e);
    });
  }, [])

  useEffect(() => {
    console.log('SubscriptionPanel - isPaying changed: ', isPaying);

    if (isPaying) {
      if (timeoutId === -1) {
        checkPayment().then(e => {
  
        }).catch(e => {
          console.error(e);
          showError(e);
        });
      }
    }
  }, [isPaying]);

  if (isLoading) {
    return <CheckPanel message={PaymentStrings.preparing_payment} />;
  }
  return (
    <Box textAlign="center" py={10} px={6}>
      <WarningTwoIcon boxSize={'50px'} color={'orange.300'} />
      <Heading as="h2" size="xl" mt={6} mb={2}>
         {PaymentStrings.add_payment_dialog.title}
      </Heading>
      <Text mt={6}>
        {PaymentStrings.add_payment_dialog.description.line1}
      </Text>
      <Text mt={6}>
        {PaymentStrings.add_payment_dialog.description.line2}
      </Text>
      <Text mt={6}>
        {PaymentStrings.add_payment_dialog.description.line3}
      </Text>

      {(isPaying && (!subscriptionContext || subscriptionContext.paymentStatus !== 'paid')) &&
      <Center mt={6}>
        <HStack justifyContent={"center"}>
          <Spinner size={"sm"} color={"orange"} />
          <Text color={"orange"}>{PaymentStrings.waiting_for_payment}</Text>
        </HStack>
      </Center>
      }

    </Box>
  )
}


function TrailUserPanel({ profile, setNeedSubscribe, updateBalance, showAddPaymentWindow }) {
  
  const [isLoading, setLoading] = useState(true);
  const [invoicePreview, setInvoicePreview] = useState(null);
  const [products, setProducts] = useState([]);
  const [usageCounting, setUsageCounting] = useState(null);


  const renderTiers = (tiers) => {
    if (!tiers || tiers.length === 0) {
      return <Text>{"Free"}</Text>;
    }
    return (
      <Box>
        {tiers.map((tier, index) => {
          return (
            <Box key={index}>
              <Text>{"Up to " + (tier.up_to || "infinity") + " - $" + (tier.unit_amount / 100).toFixed(2) + " / unit"}</Text>
            </Box>
          );
        })}
      </Box>
    );
  }

  const calculatePendingAmount = (object) => {
    const {
        products,
        usageCounting
    } = object;
    
    const email_product = products.filter((product) => product.pid === "email")[0];
    const sms_product = products.filter((product) => product.pid === "sms")[0];
    const bridge_product = products.filter((product) => product.pid === "bridge")[0];
    const contract_product = products.filter((product) => product.pid === "contract")[0];

    const pendingEmailAmount = calculateTotalAmount(email_product, 0, usageCounting.email_sent, true);
    const pendingSmsAmount = calculateTotalAmount(sms_product, 0, usageCounting.sms_sent, true);
    const pendingBridgeAmount = calculateTotalAmount(bridge_product, 0, usageCounting.bridge_sent, true);
    const pendingContractAmount = calculateTotalAmount(contract_product, 0, usageCounting.contract_created, true);

    return {
      total: pendingEmailAmount.total + pendingSmsAmount.total + pendingBridgeAmount.total + pendingContractAmount.total,
      lines: [...pendingEmailAmount.lines, ...pendingSmsAmount.lines, ...pendingBridgeAmount.lines, ...pendingContractAmount.lines],
    };
  };
  useEffect(() => {

    const fetchAllProducts = () => {
      return window.plexiMailService.getAllProductsDirectly(profile, detectLanguage())
    };
    const getUsageCounting = () => {
      return window.plexiMailService.getUsageCounting(profile)
    };

    const fetchAll = async() => {
      setLoading(true);

      fetchAllProducts().then((result) => {
        if (!result) {
          throw new Error(PaymentStrings.failed_to_generate_invoice);
        }
        setProducts(result.data);
        return getUsageCounting().then(res => {
          if (!res) {
            throw new Error(PaymentStrings.failed_to_generate_invoice);
          }
          setUsageCounting(res.data);
          return {products: result, usage: res};
        })
      }).then(result => {

        const ip = calculatePendingAmount({products: result.products, usageCounting: result.usage})
        // const ip = {
        //   lines: {
        //     data: []
        //   },
        //   total: result.usage.totalAmount
        // };


        // for (const p of result.products) {
        //   let count_id = "sms_sent";
        //   if (p.pid === "sms") {
        //     count_id = "sms_sent";
        //   } else if (p.pid === "email") {
        //     count_id = "email_sent";
        //   } else if (p.pid === "contract") {
        //     count_id = "contract_created";
        //   }

        //   ip.lines.data.push({
        //     description: renderTiers(p.tiers),
        //     usage: result.usage[count_id] || 0
        //   })


        // };

        setInvoicePreview(ip);
        if (ip.total >= ACCOUNT_INITIAL_BALANCE && setNeedSubscribe) {
          setNeedSubscribe(true);
        }
        if (updateBalance) {
          updateBalance();
        }

        setLoading(false);
      }).catch(e => {
        
        setLoading(false);
        console.error(e);

        const msg = (e) ? (e.message || e.msg || e.toString()) : '';
        if (msg.indexOf(NEED_SUBSCRIPTION_MSG) >= 0) {
          if (window.showAddPaymentDialog) {
            window.showAddPaymentDialog()
            return;
          }
        }
        showError(e);
      });
    };
    if (profile) {
      fetchAll();
    }
  }, [profile]);

  if (isLoading) {
    return <CheckPanel message={PaymentStrings.loading_usage} />;
  }
  return (
    <Box>
    <Box mt={4} width={"100%"} justifyContent={"space-between"} p={2} border="1px solid #eee" borderRadius={5}>

    <Box>
      <Text fontWeight={"bold"}>{PaymentStrings.usage_for_trail_user}</Text>
    </Box>
    <Table variant="simple" w={"100%"}>

    {profile &&
      <TableCaption>
        <Text>{getRegionName(profile.country)} ({getCountryName(profile.country)})</Text>
      </TableCaption>
      }
          <Thead>
            <Tr>
              <Th>{PaymentStrings.item}</Th>
              <Th>{PaymentStrings.amount}</Th>
              {/* <Th>{Strings2.payment.unpaid_bills.col1}</Th>
              <Th>{Strings2.payment.unpaid_bills.col2}</Th> */}
            </Tr>
          </Thead>
          <Tbody>
            {
              // starting_balance
              // customer_email
              // customer_name
              // currency
              // account_country
              // account_name ai.fi.net
              // next_payment_attempt The time at which payment will next be attempted. This value will be null for invoices where collection_method=send_invoice.
              // total
              // total_excluding_tax
              // subtotal
              // subtotal_excluding_tax
              // lines...
              // amount, quantity, currency, description, pricing {unit_amount_decimal, price_details {price, product}}
            }
            {invoicePreview &&
              invoicePreview.lines &&
              invoicePreview.lines &&
              invoicePreview.lines.length > 0 &&
              invoicePreview.lines.map((item, index) => (
                <Tr key={index}>
                  <Td>{item.description}</Td>
                  <Td>$ {(item.amount / 100.0).toFixed(2)}</Td>
                </Tr>
              ))}
          </Tbody>
    
          <Tfoot>
            <Tr>
              <Th colSpan={2}>
                <Flex justify={"flex-end"} mt={4} fontWeight={"bold"}>
                  <Text align="right" textAlign={"right"}>
                    {/* {PaymentStrings.created_at} {new Date(invoicePreview.created * 1000).toLocaleDateString()}<br /> */}
                    {/* {(invoicePreview.ending_balance !== 0) && `${PaymentStrings.balance} ${((-invoicePreview.starting_balance) / 100.0).toFixed(2)}`} */}
                    {/* {(invoicePreview.ending_balance !== 0) && <br />} */}
                    {PaymentStrings.total} $ {invoicePreview && (invoicePreview.total / 100.0).toFixed(2)} <br />
                    {/* Paid: {(invoice.amount_paid / 100.0).toFixed(2)} <br /> */}
                    {/* {PaymentStrings.remaining} {((invoicePreview.amount_remaining) / 100.0).toFixed(2)} */}
                  </Text>
                </Flex>
              </Th>
            </Tr>
          </Tfoot>
        </Table>
  </Box>
    </Box>
  );
}
function SMSVerificationPanel({ subscriptionContext, setSubscriptionContext, profile, setProfile, setState }) {
  const [isLoading, setLoading] = useState(false);

  const isPhoneVerified = () => {
    if (!subscriptionContext) {
      return false;
    }
    return subscriptionContext.verified;
  };

  const sendVerificationSMS = async () => {
    try {
      setLoading(true);
      const phone = subscriptionContext.phone;
      if (!phone) {
        showError(PaymentStrings.phone_number_is_required);
        return;
      }
      const tx = await window.plexiMailService.sendVerificationSMS(phone);
      setSubscriptionContext({ ...subscriptionContext, tx: tx });
    } catch (e) {
      console.error(e);
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Text>{PaymentStrings.bind_credit_card}</Text>
      <FormControl>
        <FormLabel>
          <Text>{PaymentStrings.send_verification_code}</Text>
        </FormLabel>

        <PhoneInput
          defaultCountry="us"
          hidden={false}
          // isInvalid={!isPhoneValid((piiOptionsForRecipient[pii.id].data && piiOptionsForRecipient[pii.id].data.address) || '')}
          // value={phone || ''}
          onChange={(phone) => {
            if (!isPhoneValid(phone)) {
              phone = "";
            }
            setSubscriptionContext({ ...subscriptionContext, phone });
          }}
        />
        {/* <FormHelperText>
            <Text>
            {Strings2.payment.verification.input_verification_code}</Text>
          </FormHelperText> */}
      </FormControl>

      <FormControl mt={2}>
        <Button
          hidden={isPhoneVerified()}
          isLoading={isLoading}
          colorScheme="green"
          onClick={sendVerificationSMS}
        >
          {PaymentStrings.send}
        </Button>
      </FormControl>

      <FormControl
        mt={2}
        hidden={!subscriptionContext.tx || subscriptionContext.tx.length === 0}
      >
        <FormLabel>
          <Text>{PaymentStrings.input_verification_code}</Text>
        </FormLabel>
        <InputGroup>
          <Input
            onChange={(e) => {
              setSubscriptionContext({
                ...subscriptionContext,
                code: e.target.value,
              });
            }}
          />
        </InputGroup>
        <FormHelperText>
          <Text></Text>
        </FormHelperText>
      </FormControl>
    </Box>
  );
}

const detectLanguage = () => {
  const lang = navigator.language;
//   console.log("detectLanguage:", lang);
  if (lang.startsWith("zh")) {
    return "zh";
  } else if (lang.startsWith("en")) {
    return "en";
  } else if (lang.startsWith("es")) {
    return "es";
  } else {
    return "en";
  }
};

function SubscriptionPanel({ profile, setProfile, subscriptionContext, setSubscriptionContext, isPaying, setPaying, updateBalance }) {
  const [isLoading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  var [timeoutId, setTimeoutId] = useState(-1);

  const messageHandler = (event) => {
    console.log('event: ', event);
    if (event.data && event.data.action === 'paid') {
      checkPayment().then(e => {

      }).catch(e => {
        console.error(e);
        showError(e);
      });
      return;
    } else if (event.data && event.data.action === 'cancel') {//// 0: idle, 1: loading, 2: success, 3: failed
      setSubscriptionContext({...subscriptionContext, paymentStatus: 'cancel'})
      return;
    } else if (event.data && event.data.action === 'failure') {
      setSubscriptionContext({...subscriptionContext, paymentStatus: 'failure'})
      return;
    } 
  };

  useEffect(() => {

    const getCheckoutSession = async(checkoutSessionId) => {
      let result = await window.plexiMailService.checkSubscriptionCheckoutStatusDirectly(checkoutSessionId);
      if (result.code !== 0) {
        // return await window.plexiMailService.createSubscriptionCheckoutSession();;
        throw new Error('Failed to retrieve checkout session')
      }
      if (result.data.status === 'expired' || !result.data.url || result.data.url === '') {
        return await window.plexiMailService.createSubscriptionCheckoutSession();
      }
      
      // checkPayment().then(e => {
  
      // }).catch(e => {
      //   console.error(e);
      //   showError(e);
      // });
      return {code: 0, msg: 'success', data: {
        sessionId: result.data.id,
        url: result.data.url,
        isPaying: result.data.status === 'complete'
      }};
    };

    const getCountryCodeFromPhone = (phone) => {
      const p = phoneUtil.parseAndKeepRawInput(phone);
      return phoneUtil.getRegionCodeForNumber(p);
    };
    
    const fetchAllProductsAndCreateCheckout = () => {
      setLoading(true);

      if (subscriptionContext && subscriptionContext.phone) {
        const country = getCountryCodeFromPhone(subscriptionContext.phone);
        if (profile && profile.country && profile.country !== country) {
          profile.country = country;
        }
      }
    

      window.plexiMailService.getAllProductsDirectly(profile, detectLanguage()).then((products) => {
        setProducts(products);
        // TODO: check status of checkout session if exipred create new
        if (profile.data && profile.data.length > 0) {
          return getCheckoutSession(profile.data);
        } else {
          return window.plexiMailService.createSubscriptionCheckoutSession();
        }
      }).then((result) => {
        setLoading(false);
        if (!result || result.code !== 0) {
          throw new Error(PaymentStrings.failed_to_create_checkout_session);
        }
        setSubscriptionContext({ ...subscriptionContext, checkoutSessionId: result.data.sessionId, checkoutSessionUrl: result.data.url});
        if (!result.data.isPaying) {
          console.log('fetchAllProductsAndCreateCheckout - checkoutSessionId: ', result.data.sessionId);
          setProfile({...profile, data: result.data.sessionId});
        }
        if (result.data.isPaying) {
          setPaying(true);
        }
      }).catch((e) => {
        console.error(e);
        setLoading(false);
        showError(e);
      })
    };

    fetchAllProductsAndCreateCheckout();
    
    // window.addEventListener('message', messageHandler)
    return () => {
      console.log('Component will unmount');
      // window.removeEventListener('message', messageHandler);
      if (timeoutId !== -1) {
        clearTimeout(timeoutId);
        // timeoutId = -1;
        setTimeoutId(-1);
      }
      // 清理操作，例如取消订阅、清除定时器等
    };

  }, []);


  useEffect(() => {
    console.log('SubscriptionPanel - isPaying changed: ', isPaying);

    if (isPaying) {
      if (timeoutId === -1) {
        checkPayment().then(e => {
  
        }).catch(e => {
          console.error(e);
          showError(e);
        });
      }
    }
  }, [isPaying]);
      
          
  const doCheckPayment = async() => {
    let checkoutSessionId = subscriptionContext && subscriptionContext.checkoutSessionId;
    if (!checkoutSessionId) {
      if (profile && profile.data) {
        checkoutSessionId = profile.data;
      }
    }
    if (!checkoutSessionId) {
      return -1;
    }
    console.log('doCheckPayment - checkoutSessionId: ', checkoutSessionId);
    let result = await window.plexiMailService.checkSubscriptionCheckoutStatusDirectly(checkoutSessionId);
    if (result.code !== 0) {
      return -1;
    }
    if (result.data.paymentStatus !== 'paid') {
      return -2;
    }
    result = await window.plexiMailService.checkSubscriptionCheckoutStatus();
    if (result.code !== 0) {
      return -1;
    }
    setSubscriptionContext({...subscriptionContext, paymentStatus: result.data.paymentStatus})
    if (result.data.paymentStatus !== 'paid') {
      return -2;
    }
    const p = await window.plexiMailService.getUserProfile();
    if (p) {
      setProfile(p);
    }
    if (updateBalance) {
      updateBalance();
    }
    return 0;
  };
  
  const checkPayment = async() => {
    try {
      const res = await doCheckPayment();
      if (res === 0) {
        return;
      } else {
        const promise = new Promise((resolve, reject) => {
          const id = setTimeout(resolve, 5000);
          timeoutId = id;
          setTimeoutId(id);
        }) 
        await promise;
        await checkPayment();
      }
    } catch (e) {
      console.error(e);
      showError(e);
      await checkPayment();
    }
  };

  if (isLoading) {
    return <CheckPanel message={PaymentStrings.loading_products} />;
  }

  const renderTiers = (tiers) => {
    if (!tiers || tiers.length === 0) {
      return <Text>{"Free"}</Text>;
    }
    let preTierStart = 1;
    return (
      <Box>
        
        {tiers.map((tier, index) => {
          let pt = preTierStart;
          preTierStart = tier.up_to + 1;
          return (
            <Box key={index}>
              <Text>{`${PaymentStrings.tier} ${index + 1} (${pt} - ${(tier.up_to ? tier.up_to + ' ' + PaymentStrings.units : PaymentStrings.infinity)}) ${PaymentStrings.at} $${(tier.unit_amount / 100).toFixed(2)} / ${PaymentStrings.unit}`}</Text>
            </Box>
          );
        })}
      </Box>
    );
  }
  return (
    <Table mt={4} fontSize={"sm"} variant="simple" w={"100%"}>
      <TableCaption>
          {(isPaying && (!subscriptionContext || subscriptionContext.paymentStatus !== 'paid')) &&
          <Center>
            <HStack justifyContent={"center"}>
              <Spinner size={"sm"} color={"orange"} />
              <Text color={"orange"}>{PaymentStrings.waiting_for_payment}</Text>
            </HStack>
          </Center>
          }

        {profile && <Box width={"100%"}><Text>{getRegionName(profile.country)} ({getCountryName(profile.country)})</Text></Box>}
      </TableCaption>
      <Thead>
        <Tr>
          <Th colSpan={2}>{PaymentStrings.products}</Th>
          <Th>{PaymentStrings.description}</Th>
        </Tr>
      </Thead>
      <Tbody>
      {products && products.length > 0 && products.map((product, index) => {
        return (
          <Tr key={index}>
              <Td><FiCheck size={"16px"} color="green" /></Td>
              <Td>{product.name}</Td>
              <Td>{renderTiers(product.tiers)}</Td>
          </Tr>
        )
      })}
      
      {(!products ||
          products.length === 0) && (
          <Tr>
            <Td colSpan={3} align="center" w={"100%"} maxW={"100%"}>
              <VStack width={"100%"}>
                <Text
                  color={"rgb(74, 85, 104)"}
                  width={"100%"}
                  textAlign="center"
                  algin={"center"}
                  fontWeight={"bold"}
                  fontSize={"md"}
                >
                  {PaymentStrings.no_products}
                </Text>
                <Text
                  color="gray"
                  fontSize="sm"
                  width={"100%"}
                  algin={"center"}
                  textAlign="center"
                >
                  {PaymentStrings.no_products_description}
                </Text>
              </VStack>
            </Td>
          </Tr>
        )}
      </Tbody>
    </Table>
  );
}

function ManageSubscriptionPanel({ profile, setState, subscriptionContext, setSubscriptionContext, cancelSubscription, createSubscription }) {
  
  const [isLoading, setLoading] = useState(true);
  const [isCreating, setCreating] = useState(false);
  const [products, setProducts] = useState([]);
  const [invoicePreview, setInvoicePreview] = useState(null);
  const [customerPortalUrl, setCustomerPortalUrl] = useState(null);
  const [pendingItems, setPendingItems] = useState([]);
  const [usageCounting, setUsageCounting] = useState(null);
  const [totalPendingAmount, setTotalPendingAmount] = useState(null);

  const parseItemDescription = (description) => {
    // description example: "2 x SMS (Tier 1 $1.5/unit)"
    // parse it to {quantity: 2, product: "sms", tier: 1, unitPrice: 1.5}
    const regex = /(\d+) × (\w+) \(Tier (\d+) at \$(\d+(?:\.\d+)?)/;
    const matches = description.match(regex);
    if (matches) {
      return {
        quantity: parseInt(matches[1]),
        product: matches[2],
        tier: parseInt(matches[3]),
        unitPrice: parseFloat(matches[4]),
      };
    }
    return null;
  };
  // const translateProductName = (name) => {
  //   name = name.toLowerCase();
  //   if (name === 'sms') {
  //     return PaymentStrings.sms;
  //   } else if (name === 'email') {
  //     return PaymentStrings.email;
  //   } else if (name === 'contract') {
  //     return PaymentStrings.contract;
  //   }
  //   return name;
  // };

  const reconductItemDescription = (description) => {
    const info = parseItemDescription(description);
    if (!info) {
      return description;
    }

    const product = translateProductName(info.product);
    // info example: {quantity: 2, product: "sms", tier: 1, unitPrice: 1.5}
    // reconduct it to "2 x SMS (Tier 1 $1.5/unit)"
    return `${info.quantity} × ${product} (${PaymentStrings.tier} ${info.tier} $${info.unitPrice} / ${PaymentStrings.unit})`;
  };

  useEffect(() => {
    if (!profile.subscriptionId || profile.subscriptionId === '') {
      return;
    }

    const fetchInvoicePreview = (params) => {

      return window.plexiMailService.generateInvoicePreviewDirectly(profile).then((result) => {
        if (!result || result.code!== 0) {
          throw new Error(PaymentStrings.failed_to_generate_invoice);
        }
        return {type: "invoicePreview", data: result.data};
      })
    };
    const fetchAllProducts = () => {
      return window.plexiMailService.getAllProductsDirectly(profile, detectLanguage()).then((products) => {
        return {type: "products", data: products};
      })
    };
    const createCustomerPortal = () => {
      return window.plexiMailService.createCustomerPortalDirectly(profile).then((result) => {
        if (!result || result.code !== 0 || !result.data.url) {
          throw new Error(PaymentStrings.failed_to_create_customer_portal);
          // setCustomerPortalUrl(result.data.url)
        }
        return result.data.url;
      })
    };
    const retrieveSubscription = () => {
      return window.plexiMailService.retrieveSubscriptionDirectly(profile).then((subscription) => {
        console.log('retrieveSubscription: ', subscription);
        if (subscription && subscription.data) {
          setSubscriptionContext({...subscriptionContext, subscriptionStatus: subscription.data.status});
          return subscription.data;
        }
        return null;
      }).catch((e) => {
        console.error(e);
        showError(e);
      })
    };

    const getSubscriberPendingUsageCounting = () => {
      return window.plexiMailService.getSubscriberPendingUsageCounting(profile)
    };

    const calculatePendingAmount = (object) => {
      const {
          products,
          subscription,
          invoicePreview,
          usageCounting
      } = object;
      
      const email_product = products.filter((product) => product.pid === "email")[0];
      const sms_product = products.filter((product) => product.pid === "sms")[0];
      const bridge_product = products.filter((product) => product.pid === "bridge")[0];
      const contract_product = products.filter((product) => product.pid === "contract")[0];

      const invoice_lines = invoicePreview.lines.data;
      const email_lines = invoice_lines.filter(line => line.price.product === email_product.id);
      const sms_lines = invoice_lines.filter(line => line.price.product === sms_product.id);
      const bridge_lines = invoice_lines.filter(line => line.price.product === bridge_product.id);
      const contract_lines = invoice_lines.filter(line => line.price.product === contract_product.id);

      const email_quantity = email_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
      const sms_quantity = sms_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
      const bridge_quantity = bridge_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
      const contract_quantity = contract_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);

      const pendingEmailAmount = calculateTotalAmount(email_product, email_quantity, usageCounting.email_sent);
      const pendingSmsAmount = calculateTotalAmount(sms_product, sms_quantity, usageCounting.sms_sent);
      const pendingBridgeAmount = calculateTotalAmount(bridge_product, bridge_quantity, usageCounting.bridge_sent);
      const pendingContractAmount = calculateTotalAmount(contract_product, contract_quantity, usageCounting.contract_created);
      return {
        total: pendingEmailAmount.total + pendingSmsAmount.total + pendingBridgeAmount.total + pendingContractAmount.total,
        lines: [...pendingEmailAmount.lines, ...pendingSmsAmount.lines, ...pendingBridgeAmount.lines, ...pendingContractAmount.lines],
      };
    };

    // const generateInvoiceItemDiscription = (object, item) => {
    //   const {
    //       products,
    //       subscription,
    //       invoicePreview,
    //       usageCounting
    //   } = object;
    //   const price_id = item.price.id;
    //   const product_id = item.price.product;

      
    //   const email_product = products.filter((product) => product.pid === "email")[0];
    //   const sms_product = products.filter((product) => product.pid === "sms")[0];
    //   const contract_product = products.filter((product) => product.pid === "contract")[0];


    // }


    const fetchAll = async() => {
      setLoading(true);
      fetchAllProducts().then(result => {
        if (!result) {
          throw new Error(PaymentStrings.failed_to_get_products);
        }
        setProducts(result.data);
        return retrieveSubscription().then(subscription => {
          return {products: result.data, subscription};
        });
      }).then((result) => {
        if (result.subscription && result.subscription.status === 'active') {
            return fetchInvoicePreview(result).then(invoicePreview => {
              return {...result, invoicePreview: invoicePreview.data};
            });
        }
        return null;
      }).then((result) => {
        if (!result) {
          return null;
        }
        
        setInvoicePreview(result.invoicePreview);
        return getSubscriberPendingUsageCounting().then(usageCountingResult => {
          usageCountingResult = usageCountingResult.data ? usageCountingResult.data : usageCountingResult;
          return {...result, usageCountingResult}
        });
        
      }).then((result) => {
        if (!result) {
          return null;
        }
        // if (result.usageCountingResult.code !== 0) {
        //   throw new Error(PaymentStrings.failed_to_get_pending_items);
        // }
        setUsageCounting(result.usageCountingResult);
        let dataObject = {
          products: result.products,
          subscription: result.subscription,
          invoicePreview: result.invoicePreview,
          usageCounting: result.usageCountingResult
        };
        return dataObject;
      }).then((result) => {
        if (!result) {
          return null;
        }
        const total = calculatePendingAmount(result);
        setTotalPendingAmount(total);
        return createCustomerPortal();
      }).then((url) => {
        setLoading(false);
        if (url) {
          setCustomerPortalUrl(url);
        }
      }).catch((e) => {
        console.error(e);
        setLoading(false);
        showError(e);
      })
    };
    fetchAll();
  }, [profile]);
  if (isLoading) {
    return <CheckPanel message={PaymentStrings.loading_subscription} />;
  }
  const renderTiers = (tiers) => {
    if (!tiers || tiers.length === 0) {
      return <Text>{"Free"}</Text>;
    }
    return (
      <Box>
        {tiers.map((tier, index) => {
          return (
            <Box key={index}>
              <Text>{"Up to " + (tier.up_to || "infinity") + " - $" + (tier.unit_amount / 100).toFixed(2) + " / unit"}</Text>
            </Box>
          );
        })}
      </Box>
    );
  }
  const getSubscribeButtonTitle = () => {
    if (subscriptionContext) {
      if (subscriptionContext.subscriptionStatus === 'incomplete') {
        return PaymentStrings.renew;
      } else if (subscriptionContext.subscriptionStatus === 'incomplete_expired') {
        return PaymentStrings.renew;
      } else if (subscriptionContext.subscriptionStatus === 'trialing') {
        return PaymentStrings.renew;
      } else if (subscriptionContext.subscriptionStatus === 'active') {
        return PaymentStrings.cancel_subscription
      } else if (subscriptionContext.subscriptionStatus === 'canceled') {
        return PaymentStrings.renew;
      } else if (subscriptionContext.subscriptionStatus === 'past_due') {
        return PaymentStrings.renew;
      } else if (subscriptionContext.subscriptionStatus === 'unpaid') {
        return PaymentStrings.renew;
      } else if (subscriptionContext.subscriptionStatus === 'paused') {
        return PaymentStrings.renew;
      } else {
        return PaymentStrings.renew;
      }
    }
    return "-"
  }
  return (
    <Box>
      <Flex width={"100%"} justifyContent={"space-between"} p={2} border="1px solid #eee" borderRadius={5}>
        <Box>
          <Text fontWeight={"bold"}>{PaymentStrings.subscribe_title}</Text>
          {(PaymentStrings.auto_renew_description && PaymentStrings.auto_renew_description.length > 0) && (<Text fontSize={"xs"}>{subscriptionContext && subscriptionContext.subscriptionStatus === 'active' ? PaymentStrings.auto_renew_description : PaymentStrings.cancelled_description}</Text>)}
        </Box>
        <Center>
        <Button ml={2} isLoading={isCreating} fontSize={"sm"} colorScheme={subscriptionContext && subscriptionContext.subscriptionStatus === 'active' ? "gray" : "green"} onClick={() => {
          if (subscriptionContext && subscriptionContext.subscriptionStatus === 'active') {
            if (cancelSubscription) {
              setCreating(true);
              cancelSubscription().then((canceled) => {
                setCreating(false);
              }).catch((e) => {
                console.error(e);
                showError(e);
                setCreating(false);
              });
            }
          } else {
            if (createSubscription) {
              setCreating(true);
              createSubscription().then(() => {
                setCreating(false);
              }).catch((e) => {
                console.error(e);
                showError(e);
                setCreating(false);
              });
            }
          }
        }}>
          {getSubscribeButtonTitle()}
        </Button></Center>
      </Flex>
      {(!subscriptionContext || subscriptionContext.subscriptionStatus !== 'active' ) && 
    <Box width={"100%"} justifyContent={"space-between"} p={2} border="1px solid #eee" borderRadius={5}>

      <Box>
        <Text fontWeight={"bold"}>{PaymentStrings.prices}</Text>
      </Box>
      <Table fontSize={"sm"} mt={2} variant="simple" w={"100%"}>

        {profile &&
      <TableCaption>
        <Text>{getRegionName(profile.country)} ({getCountryName(profile.country)})</Text>
      </TableCaption>
      }
        <Thead>
          <Tr>
            <Th colSpan={2}>{PaymentStrings.products}</Th>
            <Th>{PaymentStrings.price_per_unit}</Th>
          </Tr>
        </Thead>
        <Tbody>
        {products && products.length > 0 && products.map((product, index) => {
          return (
            <Tr key={index}>
                <Td><FiCheck size={"16px"} color="green" /></Td>
                <Td>{product.name}</Td>
                <Td>{renderTiers(product.tiers)}</Td>
            </Tr>
          )
        })}
        
        {(!products ||
            products.length === 0) && (
            <Tr>
              <Td colSpan={3} align="center" w={"100%"} maxW={"100%"}>
                <VStack width={"100%"}>
                  <Text
                    color={"rgb(74, 85, 104)"}
                    width={"100%"}
                    textAlign="center"
                    algin={"center"}
                    fontWeight={"bold"}
                    fontSize={"md"}
                  >
                    {PaymentStrings.no_products}
                  </Text>
                  <Text
                    color="gray"
                    fontSize="sm"
                    width={"100%"}
                    algin={"center"}
                    textAlign="center"
                  >
                    {PaymentStrings.no_products_description}
                  </Text>
                </VStack>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
    }
    {((subscriptionContext && subscriptionContext.subscriptionStatus === 'active' )) && 
    <Box mt={4} width={"100%"} justifyContent={"space-between"} p={2} border="1px solid #eee" borderRadius={5}>

    <Box>
      <Text fontWeight={"bold"}>{PaymentStrings.usage_for_billing_cycle}</Text>
    </Box>
    <Table variant="simple" w={"100%"} fontSize={"sm"}>

    {profile &&
      <TableCaption>
        <Text>{getRegionName(profile.country)} ({getCountryName(profile.country)})</Text>
      </TableCaption>
      }
          <Thead>
            <Tr>
              <Th>{PaymentStrings.item}</Th>
              <Th>{PaymentStrings.amount}</Th>
              {/* <Th>{Strings2.payment.unpaid_bills.col1}</Th>
              <Th>{Strings2.payment.unpaid_bills.col2}</Th> */}
            </Tr>
          </Thead>
          <Tbody>
            {
              // starting_balance
              // customer_email
              // customer_name
              // currency
              // account_country
              // account_name ai.fi.net
              // next_payment_attempt The time at which payment will next be attempted. This value will be null for invoices where collection_method=send_invoice.
              // total
              // total_excluding_tax
              // subtotal
              // subtotal_excluding_tax
              // lines...
              // amount, quantity, currency, description, pricing {unit_amount_decimal, price_details {price, product}}
            }

            <Tr>
              <Td colSpan={2} align="left" w={"100%"} maxW={"100%"} fontWeight="bold">
                {PaymentStrings.accounted_title}
              </Td>
            </Tr>

            {invoicePreview && invoicePreview.starting_balance > 0 &&
              <Tr key={'invoice-start-balance'}>
                <Td>{PaymentStrings.starting_balance}</Td>
                <Td>$ {(invoicePreview.starting_balance / 100.0).toFixed(2)}</Td>
              </Tr>
            }
            {invoicePreview &&
              invoicePreview.lines &&
              invoicePreview.lines.data &&
              invoicePreview.lines.data.length > 0 &&
              invoicePreview.lines.data.map((item, index) => (
                <Tr key={'invoice-item-' + index}>
                  <Td>{reconductItemDescription(item.description)}</Td>
                  <Td>$ {(item.amount / 100.0).toFixed(2)}</Td>
                </Tr>
              ))}
            {invoicePreview && invoicePreview.invoice_pdf && invoicePreview.invoice_pdf.length > 0 &&
            <Tr>
              <Td colSpan={2} align="center" w={"100%"} maxW={"100%"}>
                <Link href={invoicePreview.invoice_pdf} target="_blank">{PaymentStrings.download_invoice_pdf}</Link>
              </Td>
            </Tr>}

            <Tr>
              <Td colSpan={2} align="right" textAlign="right"  w={"100%"} maxW={"100%"}>
                    {PaymentStrings.accounted_title} $ {invoicePreview ? (invoicePreview.amount_due / 100.0).toFixed(2) : "0.00"} <br />
              </Td>
            </Tr>
            
            {totalPendingAmount &&
            <Tr>
              <Td colSpan={2} align="left" textAlign="left" w={"100%"} maxW={"100%"} fontWeight="bold">
                {PaymentStrings.pending_title}
              </Td>
            </Tr>
            }
            
            {totalPendingAmount && totalPendingAmount.lines && totalPendingAmount.lines.length > 0 &&
            totalPendingAmount.lines.map((item, index) => (
                <Tr key={'invoice-item-pending-' + index}>
                  <Td>{item.description}</Td>
                  <Td>$ {(item.amount / 100.0).toFixed(2)}</Td>
                </Tr>
              ))
            }
            {totalPendingAmount &&
            <Tr>
              <Td colSpan={2} align="right" textAlign="right" w={"100%"} maxW={"100%"}>
                    {PaymentStrings.pending_total} $ {totalPendingAmount ? (totalPendingAmount.total / 100.0).toFixed(2) : "0.00"} <br />
              </Td>
            </Tr>
            }
          </Tbody>
    
          <Tfoot>
            <Tr>
              <Th colSpan={2}>
                <Flex justify={"flex-end"} mt={4} fontWeight={"bold"}>
                  <Text align="right" textAlign={"right"}>
                    {/* {PaymentStrings.created_at} {new Date(invoicePreview.created * 1000).toLocaleDateString()}<br /> */}
                    {/* {(invoicePreview.ending_balance !== 0) && `${PaymentStrings.balance} ${((-invoicePreview.starting_balance) / 100.0).toFixed(2)}`} */}
                    {/* {(invoicePreview.ending_balance !== 0) && <br />} */}
                    {PaymentStrings.total} $ {(invoicePreview && totalPendingAmount) ? ((invoicePreview.total + totalPendingAmount.total) / 100.0).toFixed(2) : "--.--"} <br />
                    {/* Paid: {(invoice.amount_paid / 100.0).toFixed(2)} <br /> */}
                    {/* {PaymentStrings.remaining} {((invoicePreview.amount_remaining) / 100.0).toFixed(2)} */}
                  </Text>
                </Flex>
              </Th>
            </Tr>
          </Tfoot>
        </Table>
  </Box>
  }


      <Flex mt={4} width={"100%"} justifyContent={"space-between"} p={2} border="1px solid #eee" borderRadius={5}>
      <Center>
        <Box>
          <Text fontWeight={"bold"}>{PaymentStrings.payment_title}</Text>
        </Box>
        </Center>
        
        <Button as={"a"} href={customerPortalUrl} target={"_blank"} fontSize={"sm"} isDisabled={isCreating || !customerPortalUrl} colorScheme="gray">
          {PaymentStrings.manage}
        </Button>
      </Flex>
    </Box>
  );
}

function PaymentModal({ selectedAccount, disclosure, updateBalance, gotoAddPayment, gotoSubscription}) {
  const [state, setState] = useState(0); // 0: Check, 1: GeoVerification, 2: Bill, 3: Paid
  const [profile, setProfile] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isNeedSubscribe, setNeedSubscribe] = useState(false);
  const [subscriptionContext, setSubscriptionContext] = useState({
    phone: "",
    code: "",
    tx: "",
    verified: false,
    subscriptionId: "",
    checkoutSessionId: "",
    checkoutSessionUrl: "",
    paymentStatus: "unpaid"
    
  });
  const [cancelTask, setCancelTask] = useState(null);
  const cancelDisclosure = useDisclosure();


  useEffect(() => {
    if (disclosure.isOpen) {
      // checkVerificationState().then(() => {
      //   console.log("checkVerificationState done");
      // }).catch((e) => {
      //   console.error(e);
      //   showError(e);
      // });

      if (gotoAddPayment) {
        // checkUserProfile().then(() => {
        //   console.log("checkVerificationState done");
        // }).catch((e) => {
        //   console.error(e);
        //   showError(e);
        // });
        setState(UIStatus.AddPayment);
      } else {
        checkVerificationState().then(() => {
          console.log("checkVerificationState done");
        }).catch((e) => {
          console.error(e);
          showError(e);
        });
      }
    }
  }, [disclosure.isOpen, gotoAddPayment, gotoSubscription]);

  useEffect(() => {
    if (subscriptionContext.paymentStatus === "paid") {
        setState(UIStatus.ManageSubscription);
    }
  }, [subscriptionContext]);


  const getCountryCodeFromPhone = (phone) => {
    const p = phoneUtil.parseAndKeepRawInput(phone);
    return phoneUtil.getRegionCodeForNumber(p);
  };

  const verifyPhone = async () => {
    const phone = subscriptionContext.phone;
    const code = subscriptionContext.code;
    const tx = subscriptionContext.tx;
    if (!phone || !code || !tx) {
      throw new Error(PaymentStrings.phone_number_is_required);
    }
    const country = getCountryCodeFromPhone(phone);
    const p = { country, subscriptionId: "", customerId: "", subscriptionStatus: "", data: "", isTrail: false };
    await window.plexiMailService.saveUserProfile(tx, code, p);
    setProfile(p);
    setSubscriptionContext({ ...subscriptionContext, verified: true });
  
  };

  const createSubscription = async () => {
    const subscriptionId = await window.plexiMailService.createSubscription();
    // const profile = await window.plexiMailService.getUserProfile();
    // if (!profile) {
    //   throw new Error(PaymentStrings.failed_to_load_user_info);
    // }
    
    const result = await window.plexiMailService.retrieveSubscription();
    if (result && result.data && result.data.status) {
      setSubscriptionContext({...subscriptionContext, subscriptionId: subscriptionId, subscriptionStatus: result.data.status });
    } else {
      console.error("failed to get subscription status");
    }
    if (updateBalance) {
      updateBalance();
    }
    // setSubscriptionContext({...subscriptionContext, subscriptionId: subscriptionId });
    // setProfile({ ...profile });
  };
  const cancelSubscription = async () => {
    const task = Promise.withResolvers();
    setCancelTask(task);
    cancelDisclosure.onOpen();
    const confirmed = await task.promise;
    if (!confirmed) {
      return false;
    }

    const subscriptionId = await window.plexiMailService.cancelSubscription();
    // const profile = await window.plexiMailService.getUserProfile();
    const result = await window.plexiMailService.retrieveSubscription();
    if (result && result.data && result.data.status) {
      setSubscriptionContext({...subscriptionContext, subscriptionId: subscriptionId, subscriptionStatus: result.data.status });
    } else {
      console.error("failed to get subscription status");
    }
    
    if (profile) {
      
      if (!profile.country || profile.country === "") {
        if (profile.isTrail) {
          setState(UIStatus.TrailUser);
        } else {
          setState(UIStatus.Subscribe);
        }
      } else if (!isPlexiMailSubscribed(profile)) {
        setState(UIStatus.Subscribe);
      } else {
        setState(UIStatus.ManageSubscription);
      }
    } else {
      setState(UIStatus.Subscribe);
    }
    if (updateBalance) {
      updateBalance();
    }
    return true;
  };

  const retrieveSubscription = () => {
    return window.plexiMailService.retrieveSubscriptionDirectly(profile).then((subscription) => {
      console.log('retrieveSubscription: ', subscription);
      if (subscription && subscription.data) {
        setSubscriptionContext({...subscriptionContext, subscriptionStatus: subscription.data.status});
        return subscription.data;
      }
      return null;
    }).catch((e) => {
      console.error(e);
      showError(e);
    })
  };
  useEffect(() => {
    if (state === UIStatus.Check) {
      // do something
    } else if (state === UIStatus.Subscribe) {
      // do something
    } else if (state === UIStatus.ManageSubscription) {
      // do something
    }
  }, [state]);

  const isPlexiMailSubscribed = (profile) => {
    if (!profile) {
      return false;
    }
    if (profile.data !== "") {
      return false;
    }
    if (!profile.subscriptionId) {
      return false;
    }
    if (profile.subscriptionId === "") {
      return false;
    }
    return true;
  };
  const checkUserProfile = async () => {

    const p = await window.plexiMailService.getUserProfile(false);
    setProfile(p);

  };

  const checkVerificationState = async () => {

    const p = await window.plexiMailService.getUserProfile(false);
    setProfile(p);

    if (p) {
      if (!p.country || p.country === "") {
        if (p.isTrail) {
          setState(UIStatus.TrailUser);
        } else {
          setState(UIStatus.Subscribe);
        }
      } else if (!isPlexiMailSubscribed(p)) {
        setState(UIStatus.Subscribe);
      } else {
        const subscription = await window.plexiMailService.retrieveSubscriptionDirectly(p);
        if (subscription && subscription.data) {
          setSubscriptionContext({...subscriptionContext, subscriptionStatus: subscription.data.status});
          if (subscription.data.status !== p.subscriptionStatus) {
            if (p.data && p.data.length > 0) {
              await window.plexiMailService.checkSubscriptionCheckoutStatus();
            }
            if (subscription.data.status !== "past_due") {
              setProfile({...p, subscriptionStatus: subscription.data.status});
            }
          }
        }
        setState(UIStatus.ManageSubscription);
      }
    } else {
      const total = await window.plexiMailService.getTrailAccountBalance(profile);
      if (total > 0 || !gotoSubscription) {
        const p = { country: "US", subscriptionId: "", customerId: "", subscriptionStatus: "", data: "", isTrail: false };
        setProfile(p);
        setState(UIStatus.TrailUser);
      } else {
        const p = { country: "US", subscriptionId: "", customerId: "", subscriptionStatus: "", data: "", isTrail: false };
        await window.plexiMailService.saveUserProfile("x", "y", p);
        setProfile(p);
        setState(UIStatus.Subscribe);
      }
    }
  };

  const prevButtonHidden = () => {
    if (state === UIStatus.Check) {
      return true;
    } else if (state === UIStatus.AddPayment) {
      return false;
    } else if (state === UIStatus.TrailUser) {
      return true;
    } else if (state === UIStatus.Subscribe) {
      return true;
    } else if (state === UIStatus.ManageSubscription) {
      return true;
    }
  }
  const nextButtonHidden = () => {
    if (state === UIStatus.Check) {
      return true;
    } else if (state === UIStatus.AddPayment) {
      return false;
    } else if (state === UIStatus.TrailUser) {
      return !isNeedSubscribe;
      // return false;
    } else if (state === UIStatus.Subscribe) {
      return false;
    } else if (state === UIStatus.ManageSubscription) {
      return true;
    }
  }

  const nextButtonDisabled = () => {
    if (state === UIStatus.Check) {
      return false;
    } else if (state === UIStatus.AddPayment) {
      return false;
    } else if (state === UIStatus.TrailUser) {
      return false;
    } else if (state === UIStatus.Subscribe) {
      return false;
    } else if (state === UIStatus.ManageSubscription) {
      return false;
    }
  };

  const prevButtonColorSchema = () => {
    if (state === UIStatus.Check) {
      return "gray";
    } else if (state === UIStatus.AddPayment) {
      return "green";
    } else if (state === UIStatus.TrailUser) {
      return "gray";
    } else if (state === UIStatus.Subscribe) {
      return "gray";
    } else if (state === UIStatus.ManageSubscription) {
      return "gray";
    }
    return "gray";
  };

  const nextButtonColorSchema = () => {
    if (state === UIStatus.Check) {
      return "green";
    } else if (state === UIStatus.AddPayment) {
      return "gray";
    } else if (state === UIStatus.TrailUser) {
      return "green";
    } else if (state === UIStatus.Subscribe) {
      return "green";
    } else if (state === UIStatus.ManageSubscription) {
      return "green";
    }
    return "green";
  };
  

  const backButtonText = () => {
    if (state === UIStatus.Check) {
    } else if (state === UIStatus.AddPayment) {
      return PaymentStrings.add_payment_dialog.add_now;
    } else if (state === UIStatus.TrailUser) {
      return PaymentStrings.back;
    } else if (state === UIStatus.Subscribe) {
      return PaymentStrings.back;
    } else if (state === UIStatus.ManageSubscription) {
      return PaymentStrings.close;
    }
  };
  const nextButtonText = () => {
    if (state === UIStatus.Check) {
      return PaymentStrings.next;
    } else if (state === UIStatus.AddPayment) {
      return PaymentStrings.add_payment_dialog.add_later;
    } else if (state === UIStatus.TrailUser) {
      return PaymentStrings.subscribe;
    } else if (state === UIStatus.Subscribe) {
      return PaymentStrings.subscribe;
    } else if (state === UIStatus.ManageSubscription) {
      return "";
    }
  };

  const nextClicked = () => {
    if (state === UIStatus.Check) {
      // do something
    } else if (state === UIStatus.AddPayment) {
      closeModal();
    }  else if (state === UIStatus.TrailUser) {
      if (profile && profile.country && profile.country.length > 0) {

        setLoading(true);
        const p1 = { country: "US", subscriptionId: "", customerId: "", subscriptionStatus: "", data: "", isTrail: false };
        window.plexiMailService.saveUserProfile("x", "y", p1).then(() => {
          setProfile(p1);
          setLoading(false);
          setState(UIStatus.Subscribe);
        }).catch(e => {
          setLoading(false);
          console.error(e);
          showError(e);
        });
      } else {
        setLoading(true);
        const p1 = { country: "US", subscriptionId: "", customerId: "", subscriptionStatus: "", data: "", isTrail: false };
        window.plexiMailService.saveUserProfile("x", "y", p1).then(() => {
          setProfile(p1);
          setLoading(false);
          setState(UIStatus.Subscribe);
        }).catch(e => {
          setLoading(false);
          console.error(e);
          showError(e);
        });
      }
        // setProfile(p);
    } else if (state === UIStatus.Subscribe) {
      setLoading(true);

      return true;
    }
  };

  const backClicked = () => {
    if (state === UIStatus.Check) {
      closeModal();
    } else if (state === UIStatus.AddPayment) {
        setLoading(true);
        return true;
    } else if (state === UIStatus.ManageSubscription) {
      closeModal();
    }
  };

  const closeModal = () => {
    setState(UIStatus.Check);
    setProfile(null);
    setLoading(false);
    setSubscriptionContext({
      phone: "",
      code: "",
      tx: "",
      verified: false,
      subscriptionId: "",
      checkoutSessionId: "",
      checkoutSessionUrl: "",
      paymentStatus: "unpaid"
    });
    disclosure.onClose();
  };
  return (
    <>
    <CancelAlert disclosure={cancelDisclosure} onCompleted={(confirmed) => {
      cancelTask.resolve(confirmed);
    }} />
    <Modal
      size={"xl"}
      isOpen={disclosure.isOpen}
      onClose={() => {
        closeModal();
      }}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>
          {state === UIStatus.Check && PaymentStrings.check_payment_config}
          {state === UIStatus.Subscribe && PaymentStrings.create_subscription}
          {state === UIStatus.ManageSubscription && PaymentStrings.manage_subscription}

          </Text>
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody>
          {state === UIStatus.Check && <CheckPanel message={PaymentStrings.check_payment_configuration} />}
          {state === UIStatus.AddPayment && (
          <AddPaymentPanel
            profile={profile}
            setProfile={setProfile}
            subscriptionContext={subscriptionContext}
            setSubscriptionContext={setSubscriptionContext}
            isPaying={isLoading}
            setPaying={setLoading}
            updateBalance={updateBalance}
          />)}
          
          {state === UIStatus.TrailUser && <TrailUserPanel profile={profile} setNeedSubscribe={setNeedSubscribe} updateBalance={updateBalance} />}
          {state === UIStatus.Subscribe && (
            <SubscriptionPanel
              profile={profile}
              setProfile={setProfile}
              subscriptionContext={subscriptionContext}
              setSubscriptionContext={setSubscriptionContext}
              isPaying={isLoading}
              setPaying={setLoading}
              updateBalance={updateBalance}
            />
          )}
          
          {state === UIStatus.ManageSubscription && (
            <ManageSubscriptionPanel
            profile={profile}
            setState={setState}
            subscriptionContext={subscriptionContext}
            setSubscriptionContext={setSubscriptionContext}
            createSubscription={createSubscription}
            cancelSubscription={cancelSubscription}
          />
          )}
        </ModalBody>

        <ModalFooter>
         {(state === UIStatus.AddPayment) &&
            <Button
              as={"a"}
              href={subscriptionContext.checkoutSessionUrl}
              target={"_blank"}
              rel="opener"
              hidden={prevButtonHidden()} 
              onClick={backClicked} 
              isLoading={isLoading}
              isDisabled={!subscriptionContext.checkoutSessionUrl || subscriptionContext.checkoutSessionUrl.length <= 0}
              colorScheme={prevButtonColorSchema()} mr={4}>
              {backButtonText()}
            </Button>
          }

          {state !== UIStatus.AddPayment && 
          <Button hidden={prevButtonHidden()} colorScheme={prevButtonColorSchema()} onClick={backClicked} mr={4}>
            {backButtonText()}
          </Button>}

          {state !== UIStatus.Subscribe && 
          <Button
            hidden={nextButtonHidden()}
            colorScheme={nextButtonColorSchema()}
            isLoading={isLoading && state !== UIStatus.AddPayment}
            isDisabled={nextButtonDisabled()}
            onClick={nextClicked}
          >
            {nextButtonText()}
          </Button>
        }
        {(state === UIStatus.Subscribe && subscriptionContext.checkoutSessionUrl && subscriptionContext.checkoutSessionUrl.length > 0) && 
          <Button
            as={"a"}
            href={subscriptionContext.checkoutSessionUrl}
            target={"_blank"}
            rel="opener" 
            hidden={nextButtonHidden()}
            colorScheme={nextButtonColorSchema()}
            isLoading={isLoading}
            isDisabled={nextButtonDisabled()}
            onClick={nextClicked}
          >
            {nextButtonText()}
          </Button>
        }
        </ModalFooter>
      </ModalContent>
    </Modal></>
  );
}

export default PaymentModal;
